<script setup>
/* eslint-disable vue/no-v-html */
import SddsIconCustom from './SddsIconCustom.vue';

const props = defineProps({
  linkExpired: {
    type: Boolean,
    default: false,
  },
});

const pageUnavailableText = props.linkExpired ? 'pageUnavailableTextLinkExpired' : 'pageUnavailableTextLinkIncorrect';

</script>

<template>
  <div class="container">
    <div class="text-content">
      <h1>{{ $i18n('pageUnavailableHeader') }}</h1>
      <p v-html="$i18n(pageUnavailableText)" />
      <p>
        <SddsIconCustom name="email" />
        <a :href="`mailto:${$i18n('pageUnavailableMail')}`">{{ $i18n('pageUnavailableMail') }}</a>
      </p>
    </div>
    <div class="image-content">
      <img
        src="../assets/R_460_A4x2NA-3.png"
        alt="404"
      >
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 20px;
  height: 100%;
  padding: 0 20px;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: var(--sdds-spacing-element-48);
}

.text-content {
  flex: 3;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.image-content {
  flex: 2;
  text-align: center;
}

.image-content img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .image-content img {
    max-width: 70%;
  }
}
</style>
